import api from '../api';

export const getStylization = async () => {
  const url = `/visualNetAtend`;
  console.log('[DEBUG][styles/service] getStylization chamado, url:', url);
  return await api.get(url);
};
